"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commodityCode = exports.newPriceDenomination = exports.priceDenomination = exports.euFitLabel = exports.usFitLabel = exports.ukFitLabel = exports.occasion = exports.backInStockNotificationsEnabled = exports.backInStockNotificationsDisabled = exports.pairsPerCarton = exports.euFit = exports.usFit = exports.ukFit = exports.euSize = exports.usSize = exports.ukSize = exports.globalFit = exports.globalSize = exports.upc = exports.ean = exports.variantWeight = exports.variantHeight = exports.variantWidth = exports.variantLength = void 0;
const i18n_1 = require("../common/i18n");
exports.variantLength = {
    name: 'length',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Length'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.variantWidth = {
    name: 'width',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Width'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.variantHeight = {
    name: 'height',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Height'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.variantWeight = {
    name: 'weight',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Weight'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.ean = {
    name: 'ean',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('EAN'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: true,
};
exports.upc = {
    name: 'upc',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('UPC'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
const globalSize = (attributeConstraint = 'CombinationUnique', isRequired = true) => ({
    name: 'globalSize',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Global Size'),
    attributeConstraint,
    isRequired,
    isSearchable: false,
});
exports.globalSize = globalSize;
const globalFit = (attributeConstraint = 'CombinationUnique', isRequired = true) => ({
    name: 'globalFit',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Global Fit'),
    attributeConstraint,
    isRequired,
    isSearchable: false,
});
exports.globalFit = globalFit;
exports.ukSize = {
    name: 'ukSize',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('UK Size'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.usSize = {
    name: 'usSize',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('US Size'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.euSize = {
    name: 'euSize',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Europe Size'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.ukFit = {
    name: 'ukFit',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('UK Fit'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.usFit = {
    name: 'usFit',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('US Fit'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.euFit = {
    name: 'euFit',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Europe Fit'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.pairsPerCarton = {
    name: 'pairsPerCarton',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Pairs per carton'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
/**
 * @deprecated Use `backInStockNotificationsEnabled` instead.
 */
exports.backInStockNotificationsDisabled = {
    name: 'backInStockNotificationsDisabled',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Back in stock notifications disabled'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.backInStockNotificationsEnabled = {
    name: 'backInStockNotificationsEnabled',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Back in stock notifications enabled'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.occasion = {
    name: 'occasion',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Occasion'),
    attributeConstraint: 'CombinationUnique',
    isRequired: true,
    isSearchable: false,
};
exports.ukFitLabel = {
    name: 'ukFitLabel',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('UK Fit Label'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.usFitLabel = {
    name: 'usFitLabel',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('US Fit Label'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.euFitLabel = {
    name: 'euFitLabel',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Europe Fit Label'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.priceDenomination = {
    name: 'priceDenomination',
    type: {
        name: 'number',
    },
    label: (0, i18n_1.localizedString)('Price Denomination'),
    attributeConstraint: 'CombinationUnique',
    isRequired: true,
    isSearchable: false,
};
exports.newPriceDenomination = {
    name: 'priceDenomination',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Price Denomination'),
    attributeConstraint: 'CombinationUnique',
    isRequired: true,
    isSearchable: false,
};
exports.commodityCode = {
    name: 'commodityCode',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Commodity Code'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
//# sourceMappingURL=variant-attributes.js.map